import Skeleton from 'react-loading-skeleton';
import S from './BillingPageSkeleton.module.scss';
export const InvoicePageSkeleton = () => {
  return <div className={S.layout} data-sentry-component="InvoicePageSkeleton" data-sentry-source-file="InvoicePageSkeleton.tsx">
      <section style={{
      display: 'flex',
      justifyContent: 'space-between',
      marginRight: '240px'
    }}>
        <div>
          <Skeleton width={150} height={38} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          <Skeleton width={150} height={38} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
        </div>
        <div>
          <Skeleton width={150} height={25} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          <Skeleton width={140} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          <Skeleton width={250} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          <Skeleton width={400} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
        </div>
      </section>
      <section style={{
      display: 'flex',
      gap: '250px',
      marginTop: '80px'
    }}>
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '50px'
      }}>
          <div>
            <Skeleton width={170} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={250} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          </div>
          <div>
            <Skeleton width={170} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={250} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          </div>
        </div>
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '50px'
      }}>
          <div>
            <Skeleton width={150} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          </div>
          <div>
            <Skeleton width={150} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={300} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          </div>
          <div>
            <Skeleton width={100} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={150} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          </div>
        </div>
      </section>
      <section style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '50px',
      marginTop: '80px'
    }}>
        <div>
          <Skeleton width={170} height={30} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
        </div>
      </section>
      <section style={{
      display: 'flex',
      flexDirection: 'column',
      marginTop: '70px',
      gap: '40px',
      marginRight: '150px'
    }}>
        <div style={{
        display: 'flex',
        justifyContent: 'space-between'
      }}>
          <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
        </div>
        <div style={{
        display: 'flex',
        justifyContent: 'space-between'
      }}>
          <div>
            <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={270} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          </div>
          <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
        </div>
        <div style={{
        display: 'flex',
        justifyContent: 'space-between'
      }}>
          <div>
            <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={270} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          </div>
          <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
        </div>
        <div style={{
        display: 'flex',
        justifyContent: 'space-between'
      }}>
          <div>
            <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
            <Skeleton width={270} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          </div>
          <Skeleton width={200} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
        </div>
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginLeft: '450px'
      }}>
          <Skeleton width={170} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
          <Skeleton width={250} height={20} data-sentry-element="Skeleton" data-sentry-source-file="InvoicePageSkeleton.tsx" />
        </div>
      </section>
    </div>;
};